import type { ReactNode } from 'react';
import { Card, CardAction, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/** A card with an optional header; `flush` removes body padding so tables run edge to edge. */
export function SectionCard({ title, description, actions, children, flush, className }: {
  title?: ReactNode; description?: ReactNode; actions?: ReactNode; children: ReactNode; flush?: boolean; className?: string;
}) {
  return (
    <Card className={cn('gap-0 overflow-hidden py-0', className)}>
      {(title || actions) && (
        <CardHeader className="border-b px-5 py-4 [.border-b]:pb-4">
          {title && <CardTitle className="text-base">{title}</CardTitle>}
          {description && <CardDescription>{description}</CardDescription>}
          {actions && <CardAction className="flex items-center gap-2">{actions}</CardAction>}
        </CardHeader>
      )}
      <CardContent className={cn(flush ? 'p-0' : 'p-5')}>{children}</CardContent>
    </Card>
  );
}
